import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce974172"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"float":"left"} }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { style: {"float":"left"} }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_miezz_foreign_multiple_select = _resolveComponent("miezz-foreign-multiple-select")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_miezz_card = _resolveComponent("miezz-card")!

  return (_openBlock(), _createBlock(_component_miezz_card, { fix: true }, {
    default: _withCtx(() => [
      _createVNode(_component_miezz_form, {
        ref: "ruleForm",
        modelValue: _ctx.form,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form) = $event))
      }, {
        "form-item": _withCtx(({ item }) => [
          (item.Prop == 'CustomerLabel')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                prop: item.Prop,
                label: item.Label
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_miezz_input, {
                    ref: "ref-company-label",
                    modelValue: _ctx.form.Data.CustomerLabel,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.CustomerLabel) = $event)),
                    "fetch-suggestions": _ctx.getCompanies,
                    "trigger-on-focus": true,
                    clearable: "",
                    valueKey: "Name",
                    onHandleSelect: _ctx.handleSelectCompany,
                    onHandleChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSelectCompany()))
                  }, null, 8, ["modelValue", "fetch-suggestions", "onHandleSelect"])
                ]),
                _: 2
              }, 1032, ["prop", "label"]))
            : (item.Prop == 'Methods')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_foreign_multiple_select, {
                      modelValue: _ctx.form.Data.Methods,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.Methods) = $event)),
                      allowCreate: true,
                      prop: "Method",
                      options: _ctx.methods
                    }, {
                      default: _withCtx(({ model }) => [
                        _createElementVNode("span", _hoisted_1, _toDisplayString(model.label), 1),
                        (model.data.Data)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              style: {"float":"right","color":"red","margin-right":"10px"},
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.handleDeleteLink('Method', model.label))
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Delete)
                                ]),
                                _: 1
                              })
                            ], 8, _hoisted_2))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : (item.Prop == 'FollowUpPersonId')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 2,
                    prop: item.Prop,
                    label: item.Label
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_select, {
                        modelValue: _ctx.form.Data.FollowUpPersonId,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Data.FollowUpPersonId) = $event)),
                        label: _ctx.form.Data.FollowUpPersonLabel,
                        "onUpdate:label": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Data.FollowUpPersonLabel) = $event)),
                        options: _ctx.users
                      }, null, 8, ["modelValue", "label", "options"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "label"]))
                : (item.Prop == 'PlanFollowUpTime')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.form.Data.PlanFollowUpTime,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Data.PlanFollowUpTime) = $event)),
                          type: "datetime",
                          format: "YYYY/MM/DD HH:mm",
                          "value-format": "YYYY/MM/DD HH:mm",
                          class: _normalizeClass('form-item-date')
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : (item.Prop == 'PlanCompleteTime')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 4,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.PlanCompleteTime,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.Data.PlanCompleteTime) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: _normalizeClass('form-item-date')
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : (item.Prop == 'AreaLabel')
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 5,
                          prop: item.Prop,
                          label: item.Label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_miezz_input, {
                              modelValue: _ctx.form.Data.AreaLabel,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Data.AreaLabel) = $event)),
                              "fetch-suggestions": _ctx.getAreas,
                              "trigger-on-focus": true,
                              clearable: "",
                              valueKey: "FullName"
                            }, null, 8, ["modelValue", "fetch-suggestions"])
                          ]),
                          _: 2
                        }, 1032, ["prop", "label"]))
                      : (item.Prop == 'InnerAccompanyPeople')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 6,
                            prop: item.Prop,
                            label: item.Label
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_foreign_multiple_select, {
                                modelValue: _ctx.form.Data.InnerAccompanyPeople,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.Data.InnerAccompanyPeople) = $event)),
                                prop: "InnerAccompanyPersonId",
                                options: 
              _ctx.users.filter((it) => it.Value != _ctx.form.Data.FollowUpPersonId)
            
                              }, null, 8, ["modelValue", "options"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "label"]))
                        : (item.Prop == 'Contents')
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 7,
                              prop: item.Prop,
                              label: item.Label
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_foreign_multiple_select, {
                                  modelValue: _ctx.form.Data.Contents,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.Data.Contents) = $event)),
                                  allowCreate: true,
                                  prop: "Content",
                                  options: _ctx.contents
                                }, {
                                  default: _withCtx(({ model }) => [
                                    _createElementVNode("span", _hoisted_3, _toDisplayString(model.label), 1),
                                    (model.data.Data)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          style: {"float":"right","color":"red","margin-right":"10px"},
                                          href: "javascript:;",
                                          onClick: ($event: any) => (_ctx.handleDeleteLink('Content', model.label))
                                        }, [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Delete)
                                            ]),
                                            _: 1
                                          })
                                        ], 8, _hoisted_4))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "options"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "label"]))
                          : (item.Prop == 'Files')
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 8,
                                prop: item.Prop,
                                label: item.Label
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_upload, {
                                    modelValue: _ctx.form.Data.Files,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.Data.Files) = $event)),
                                    path: "company/follow-up-record/file",
                                    prop: "File",
                                    maxSize: 2 * 1024 * 1024
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["prop", "label"]))
                            : (item.Prop == 'Link')
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 9,
                                  label: item.Label
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      prop: `LinkLabel`,
                                      class: "link-label"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          modelValue: _ctx.form.Data.LinkLabel,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.Data.LinkLabel) = $event)),
                                          placeholder: "请填写超链接文本"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      prop: `Link`,
                                      class: "link-href"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          modelValue: _ctx.form.Data.Link,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.Data.Link) = $event)),
                                          placeholder: "请填写超链接"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_miezz_button_bar, {
        modelValue: _ctx.buttons,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.buttons) = $event)),
        onHandleClick: _ctx.handleClick
      }, null, 8, ["modelValue", "onHandleClick"])
    ]),
    _: 1
  }))
}